var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "notice-section" }, [
    _c("div", { staticClass: "content-max-width" }, [
      _c("h4", { domProps: { innerHTML: _vm._s(_vm.content) } }),
      _vm._v(" "),
      _c("a", { staticClass: "exit", on: { click: _vm.closePopup } }, [
        _c("span"),
        _vm._v(" "),
        _c("span")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-089c20c3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-089c20c3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/PageNotice.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-089c20c3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/PageNotice.vue
// module chunks = 0